import { Helpers } from '../../helpers';
import { IModule } from '../../interfaces/imodule';
import { AssetMappingConfiguration } from '../asset-mapping-configuration';

export class ModuleBase {
  ModuleId: number;
  Name: string;
  Description: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  AssetMappingConfigurations_Module?: Array<AssetMappingConfiguration> | null;

  constructor(item?: IModule) {
    if (item) {

      this.ModuleId = item.ModuleId;
      this.Name = item.Name;
      this.Description = item.Description;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.AssetMappingConfigurations_Module = Helpers.createClassArray(AssetMappingConfiguration, item.AssetMappingConfigurations_Module);
    }
  }
}